module.exports = __webpack_public_path__ + "../../dist/Messanger/img/profile-photo-2.d8b8281d.jpg";